// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-primary[data-v-68b3e12b] {\n    margin-right: 10px;\n}\n.name .icon[data-v-68b3e12b] {\n    font-size: larger;\n}\n", ""]);
// Exports
module.exports = exports;
